// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"452":"ae35617d","548":"0ae94e8f","750":"13ce0fb5","791":"69dd8c94","822":"d4905298","826":"88c89607"}[chunkId] + ".1793406085688.chunk.js";
};